import React, { Fragment, useEffect } from "react";
import { useParams } from "react-router-dom";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import ServiceDetails from "./ServiceDetails";
import services from "../../api/services";

const SeviceSinglePage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const service = services.find((s) => s.slug === slug);
  const pageTitle = service ? service.title : "Service details";

  useEffect(() => {
    document.title = `${pageTitle} | SMMPanel-Cheap`;
  }, [pageTitle]);

  return (
    <Fragment>
      <div className="about-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <PageTitle pageTitle={pageTitle} pagesub={pageTitle} />
            <ServiceDetails />
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default SeviceSinglePage;
